import { __assign } from "tslib";
import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import NonFungibleButton from './NonFungibleButton';
import ActionBarItemWrapper from '../../ActionBar/_partials/items/ActionBarItemWrapper';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import AssetIcon from './Icon';
import FunigbleButton from './FungibleButton';
export var Button = function (props) {
    var _a;
    var deviation = props.deviation, digitalAsset = props.deviation.digitalAsset, isCreator = props.isCreator, openListingModal = props.openListingModal;
    var digital_assets = useFlag('digital_assets');
    if (!digital_assets) {
        return null;
    }
    // Allow asset creation for deviation author
    if (!digitalAsset && isCreator) {
        return (React.createElement(ActionBarItemWrapper, { tooltip: 'Turn this deviation into a collectible' },
            React.createElement(GhostButton, { size: 'medium', variant: 'edit-purple', icon: AssetIcon, onClick: function () { return openListingModal && openListingModal(deviation); } }, "Sell as Collectible")));
    }
    if ((_a = deviation.digitalAsset) === null || _a === void 0 ? void 0 : _a.hasEditions) {
        return React.createElement(FunigbleButton, __assign({}, props));
    }
    else {
        return React.createElement(NonFungibleButton, __assign({}, props));
    }
};
Button.displayName = 'DasButton';
export default Button;
//# sourceMappingURL=Button.js.map